<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    width="900px"
    custom-class="peopleDialog">
    <div class="title" slot="title">
      联系我们
    </div>
      <div class="form-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="ruleFormYan">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="姓名" ref="name" prop="name">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.name" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="电话" ref="phone" prop="phone">
                <div class="flex justify-start align-center">
                  <el-input v-model="ruleForm.phone" class="inp"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="内容" class="listcontent" ref="content" prop="content">
                <div class="flex justify-start align-center">
                  <el-input type="textarea" v-model="ruleForm.content" class="inp">
                  </el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <div class="flex justify-start align-center">
                <div class="btn-box">
                  <div class="btn" @click="submitForm('ruleForm')">提交</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
  </el-dialog>
</template>
<script>
import {imgUrl} from "@/config";
import {org_connect,} from "@/api";
import rules from '@/utils/rules'
export default {
  name: "peopleDialog",
  data() {
    return {
      imgUrl:imgUrl,
      classes:[],
      ruleForm:{
        name: '',
        phone: '',
        content: ''
      },
      rules:{
        content: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        name: [
          {required: false, message: '请输入', trigger: 'blur'}
        ],
        phone: [
          {required: false, message: '请输入', trigger: 'blur'},
          rules.phone
        ],
      }
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  created() {

  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },

    async submitInfo(){
      let _data = await org_connect(
        this.ruleForm.name,
        this.ruleForm.phone,
        this.ruleForm.content
      );
      if(_data.status == 200){
        this.$message.success(_data.msg)
        this.handleClose()
      } else {
        this.$message.error(_data.msg)
      }
    },



    handleClose(){
      this.$refs.ruleForm.resetFields()
      this.$emit('handleClose',false)
    },


  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.peopleDialog {
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }
  .form-content {
    width: 100%;
    .title-flex {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 20px;

      b {
        font-size: 18px;
        color: #000000;
        font-weight: bold;
        margin-right: 10px;
      }
    }


    .width {
      width: 400px;
    }

    .btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 30px 0;

      .btn {
        width: 180px;
        height: 40px;
        background-image: linear-gradient(0deg,
          #2791ff 0%,
          #81b6ff 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        letter-spacing: 1px;
        color: #ffffff;
        cursor: pointer;
      }
    }
    .add {
      width: 24px;
      cursor: pointer;
    }

    .inp {
      flex: 1;
    }

    .tips {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      background-color: #fef0ef;
      border-radius: 4px;
      margin-left: 10px;
      font-size: 14px;
      color: #f34336;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: 16px;

      i {
        font-size: 20px;
        color: #f34336;
        margin-right: 4px;
      }
      &.short {
        width: 120px;
      }
      &.zhengm {
        width: 250px;
      }
      &.width {
        width: 350px;
      }
    }

    .look {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      border: 1px solid #2791ff;
      color: #2791ff;
      line-height: 34px;
      text-align: center;
      font-size: 14px;
      margin-left: 10px;
      border-radius: 4px;
      margin-top: 15px;
    }

    .btnUp {
      width: max-content;
      padding: 0 10px;
      height: 36px;
      margin-left: 10px;
      background-image: linear-gradient(90deg,
        #2791ff 0%,
        #81b6ff 100%);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #ffffff;

      i {
        font-size: 20px;
        color: #ffffff;
        margin-right: 5px;
        font-weight: 100;
      }
    }
  }
}
</style>


